import { createContext } from 'react'

export const RouteContext = createContext(undefined)
export const RouteProvider = RouteContext.Provider
export const RouteConsumer = RouteContext.Consumer
